import { apiFetch } from './utils/api';
//const mockedExpertInputs = require('./mocks/v1/wealth-plan/expert-input.json');

export const expertInput = {
  get: async () => {
    //return mockedExpertInputs;
    const options = {
      method: 'GET',
    };

    const url = '/v2/expert-inputs';

    const { body } = await apiFetch(url, {
      ...options,
    });

    if (body) {
      return body;
    } else {
      return { data: [] };
    }
  },
};
